import {
    ITranferirAtendimentoCliente,
    IAtendimentoDetalhadoAoCliente,
    IListarQuantidadesAtendimentos,
    IListarTodosAtendimentos,
    IResponseListarTodosAtendimentos,
} from "../../../Interfaces/AtendimentoCliente/Atendimento/AtendimentoInterfaces";
import { TModoGestaoAtendimento } from "../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import { MotivoCancelamentoInterfaceResponse } from "../../../Interfaces/Geral/GestaoDeCadastro/MotivoCancelamento/MotivoCancelamentoInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function TranferirAtendimentoService(
    props: ITranferirAtendimentoCliente
) {
    return Service(
        Axios.post(`/home/atendimentos/transferiratendimento`, props)
    );
}

export async function RemoverAtendimentoDoUsuarioService(IDCaso: number) {
    return Service(
        Axios.delete(
            `/home/atendimentos/removeratendimentousuario?IDCaso=${IDCaso}`
        )
    );
}

export async function RemoverAtendimentoDoUsuarioAcompanhamentoService(
    IDCaso: number
) {
    return Service(
        Axios.delete(
            `/home/atendimentos/removeratendimentousuarioacompanhamento?IDCaso=${IDCaso}`
        )
    );
}

export async function GetAtendimentoClienteService(IDCaso: number) {
    return Service(
        Axios.get<IAtendimentoDetalhadoAoCliente>(
            `/home/atendimentos/getdescricaocaso?idCaso=${IDCaso}`
        )
    );
}

export async function ExcluirAtendimentoService(
    idCaso: number,
    idUsuario: number
) {
    return Service(
        Axios.delete(
            `/home/atendimentos/deletaratendimento?idCaso=${idCaso}&idUsuario=${idUsuario}`
        )
    );
}

export async function ListarQuantidadeAtendimentosService() {
    return Service(
        Axios.get<IListarQuantidadesAtendimentos>(
            `/atendimentocliente/atendimentos/listarquantidadeatendimentos`
        )
    );
}

export async function ListarJustificativaCancelamentoService(
    idTipoCaso: number
) {
    return Service(
        Axios.get<Array<MotivoCancelamentoInterfaceResponse>>(
            `/home/atendimentos/listarjustificativacancelamentotipocaso?idTipoCaso=${idTipoCaso}`
        )
    );
}

export async function ListarAtendimentosService(
    ID_PAGINA: number,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento,
    requestBody: IListarTodosAtendimentos
) {
    return Service(
        Axios.post<IResponseListarTodosAtendimentos>(
            `/home/atendimentos/listaratendimentos?ID_PAGINA=${ID_PAGINA}&SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}`,
            requestBody
        )
    );
}

export async function ListarAtendimentosExportarExcelService(
    ID_PAGINA: number,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento,
    requestBody: IListarTodosAtendimentos,
    excel?: boolean
) {
    return Service(
        Axios.post<Blob>(
            `/home/atendimentos/listaratendimentos?ID_PAGINA=${ID_PAGINA}&SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}&excel=${excel}`,
            requestBody,
            { responseType: "blob" }
        )
    );
}
